import React from 'react';
import { Dispatch } from '@reduxjs/toolkit';

import { Timesheet } from '../../../../interfaces/employee/timesheet.interface';

import { TimesheetActions } from '../../../../actions/timesheet/timesheet.actions';
import { RemoveTimesheetAction } from '../../../../actions/timesheet/timesheet.types';

import { useAppDispatch, useRemoval } from '../../../../hooks';

import { Modal } from '../../../../components/modal/Modal';
import { ModalLayout } from '../../../../components/modal/ModalLayout';
import RemoveModal from '../../../../components/modal/remove/RemoveModal';

interface Props {
  onRemoval?: () => void;
}

const RemoveTimesheetContainer = ({ onRemoval }: Props) => {
  const dispatch: Dispatch<RemoveTimesheetAction> = useAppDispatch();

  const { element, showModal, setShowModal } = useRemoval();

  const onClose = () => setShowModal(false);

  const handleConfirm = (onComplete: () => void) => {
    dispatch(
      TimesheetActions.removeTimesheet((element as Timesheet).id as number, () => {
        onComplete();
        onClose();
        if (onRemoval) {
          onRemoval();
        }
      })
    );
  };

  return (
    <>
      {showModal && (
        <Modal>
          <ModalLayout onClose={onClose} title="Remove Timesheet">
            <RemoveModal title="this timesheet" onConfirm={handleConfirm} />
          </ModalLayout>
        </Modal>
      )}
    </>
  );
};

export default RemoveTimesheetContainer;
